import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "breadcrumb" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Dashboard")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Purchase History")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("li", { class: "current" }, "Order Details", -1)
const _hoisted_5 = { class: "heading-div" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", null, "Order Details", -1)
const _hoisted_7 = { class: "status-div" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Status: ")
const _hoisted_9 = { class: "container-xxl" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-lg-12 col-md-12 mb-4" }
const _hoisted_12 = { class: "card order-details" }
const _hoisted_13 = { class: "box-div" }
const _hoisted_14 = { class: "col-div" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h3", null, "TRANSACTION ID", -1)
const _hoisted_16 = { class: "col-div" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h3", null, "INSURER", -1)
const _hoisted_18 = { class: "col-div" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h3", null, "COVER TYPE", -1)
const _hoisted_20 = {
  key: 0,
  class: "col-div"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h3", null, "SUM INSURED", -1)
const _hoisted_22 = { class: "col-div" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h3", null, "TOTAL PAID", -1)
const _hoisted_24 = { class: "col-div" }
const _hoisted_25 = { style: {"cursor":"pointer"} }
const _hoisted_26 = ["href"]
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Download ")
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", {
  class: "arrow-right",
  style: {"opacity":"0"}
}, " ", -1)
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = {
  class: "dropdown-menu",
  style: {"cursor":"pointer"}
}
const _hoisted_31 = ["href"]
const _hoisted_32 = { class: "col-lg-6 col-md-12 mb-4" }
const _hoisted_33 = { class: "card detail-div" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "card-header d-flex justify-content-between align-items-center" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title mb-0 customer" }, "Customer Detail")
], -1)
const _hoisted_35 = { class: "card-body" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "1.")
], -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Name")
], -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "2.")
], -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Email")
], -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "3.")
], -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Identity Type")
], -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "4.")
], -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "IC Number")
], -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "5.")
], -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Renewal Type")
], -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "6.")
], -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Mobile Number")
], -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "7.")
], -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Postal Code")
], -1)
const _hoisted_50 = { class: "col-lg-6 col-md-12 mb-4" }
const _hoisted_51 = { class: "card detail-div" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "card-header d-flex justify-content-between align-items-center" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title mb-0 vehicle" }, "Vehicle Detail")
], -1)
const _hoisted_53 = { class: "card-body" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "1.")
], -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Type")
], -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "2.")
], -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Ownership")
], -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "3.")
], -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Registration No")
], -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "4.")
], -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Registration Year")
], -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "5.")
], -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Brand")
], -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "6.")
], -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Model")
], -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "7.")
], -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Engine CC")
], -1)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "8.")
], -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Body Type")
], -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "9.")
], -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Seaters")
], -1)
const _hoisted_72 = { class: "col-lg-6 col-md-12 mb-4" }
const _hoisted_73 = { class: "card detail-div" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("div", { class: "card-header d-flex justify-content-between align-items-center" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title mb-0 insurance" }, "Insurance Detail")
], -1)
const _hoisted_75 = { class: "card-body" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "1.")
], -1)
const _hoisted_77 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Cover Type")
], -1)
const _hoisted_78 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "2.")
], -1)
const _hoisted_79 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Sum Insured")
], -1)
const _hoisted_80 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "3.")
], -1)
const _hoisted_81 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Insurance Company")
], -1)
const _hoisted_82 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "4.")
], -1)
const _hoisted_83 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Sum Insured From")
], -1)
const _hoisted_84 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "5.")
], -1)
const _hoisted_85 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Sum Insured To")
], -1)
const _hoisted_86 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "6.")
], -1)
const _hoisted_87 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Payment Method")
], -1)
const _hoisted_88 = { class: "col-lg-6 col-md-12 mb-4" }
const _hoisted_89 = { class: "card detail-div" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("div", { class: "card-header d-flex justify-content-between align-items-center" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title mb-0 order" }, "Order Summary")
], -1)
const _hoisted_91 = { class: "card-body" }
const _hoisted_92 = { class: "order-summary" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Insurance Premium")
], -1)
const _hoisted_94 = /*#__PURE__*/_createElementVNode("span", { class: "currency" }, "RM", -1)
const _hoisted_95 = { class: "amount" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("span", { class: "minus" }, "-", -1)
const _hoisted_97 = /*#__PURE__*/_createElementVNode("span", { class: "currency" }, "RM", -1)
const _hoisted_98 = { class: "amount" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("span", { class: "currency" }, "RM", -1)
const _hoisted_100 = { class: "amount" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("span", { class: "minus" }, "-", -1)
const _hoisted_102 = /*#__PURE__*/_createElementVNode("span", { class: "currency" }, "RM", -1)
const _hoisted_103 = { class: "amount" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Total Tax")
], -1)
const _hoisted_105 = /*#__PURE__*/_createElementVNode("span", { class: "currency" }, "RM", -1)
const _hoisted_106 = { class: "amount" }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Stamp Duty")
], -1)
const _hoisted_108 = /*#__PURE__*/_createElementVNode("span", { class: "currency" }, "RM", -1)
const _hoisted_109 = { class: "amount" }
const _hoisted_110 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Administrative Fee")
], -1)
const _hoisted_111 = /*#__PURE__*/_createElementVNode("span", { class: "currency" }, "RM", -1)
const _hoisted_112 = { class: "amount" }
const _hoisted_113 = { class: "total" }
const _hoisted_114 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Total Payable")
], -1)
const _hoisted_115 = /*#__PURE__*/_createElementVNode("span", { class: "currency" }, "RM", -1)
const _hoisted_116 = { class: "amount" }
const _hoisted_117 = /*#__PURE__*/_createElementVNode("div", { class: "content-backdrop fade" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: { name: 'Dashboard' } }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: { name: 'CustomerPurchaseHistory' } }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        _hoisted_4
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("span", {
          class: _normalizeClass(["status", _ctx.order.status_label == 'Completed' ? 'completed' : 'pending'])
        }, _toDisplayString(_ctx.order.status_label), 3)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("h4", null, "#" + _toDisplayString(_ctx.order.id), 1)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("h4", null, _toDisplayString(_ctx.insurance.insurance_company_name), 1)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("h4", null, _toDisplayString(_ctx.quotation.cover_type), 1)
              ]),
              (_ctx.quotation.cover_type != '3rd Party')
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("h4", null, "RM " + _toDisplayString(_ctx.convertTo2Decimal(_ctx.quotation_package.sum_insured)), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("h4", null, "RM " + _toDisplayString(_ctx.convertTo2Decimal(_ctx.payments.amount)), 1)
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  (_ctx.order.policy_file_full_path?.length > 1)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass(["btn", 
                            _ctx.order.policy_file_full_path?.length > 1
                              ? 'dropdown-toggle'
                              : ''
                          ]),
                        "data-bs-toggle": "dropdown",
                        "aria-expanded": "false"
                      }, " Download ", 2))
                    : _createCommentVNode("", true),
                  (_ctx.order.policy_file_full_path?.length == 1)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        href: _ctx.order.policy_file_full_path,
                        target: "_blank",
                        class: "btn"
                      }, _hoisted_29, 8, _hoisted_26))
                    : _createCommentVNode("", true),
                  _createElementVNode("ul", _hoisted_30, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.order.policy_file_full_path, (policy_path, index) => {
                      return (_openBlock(), _createElementBlock("li", { key: policy_path }, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: policy_path,
                          target: "_blank"
                        }, "File " + _toDisplayString(index + 1), 9, _hoisted_31)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("table", null, [
                _createElementVNode("tr", null, [
                  _hoisted_36,
                  _hoisted_37,
                  _createElementVNode("td", null, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.quotation.customer_name), 1)
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_38,
                  _hoisted_39,
                  _createElementVNode("td", null, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.quotation.customer_email), 1)
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_40,
                  _hoisted_41,
                  _createElementVNode("td", null, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.quotation.identity_type_label), 1)
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_42,
                  _hoisted_43,
                  _createElementVNode("td", null, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.quotation.ic_no), 1)
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_44,
                  _hoisted_45,
                  _createElementVNode("td", null, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.quotation.renewal_type ? 
                        _ctx.quotation.renewal_type == '1' ? 'Renewal' : 'Transfer Owner' 
                        : ''), 1)
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_46,
                  _hoisted_47,
                  _createElementVNode("td", null, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.quotation.customer_mobile_no), 1)
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_48,
                  _hoisted_49,
                  _createElementVNode("td", null, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.quotation.postal_code), 1)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_50, [
          _createElementVNode("div", _hoisted_51, [
            _hoisted_52,
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("table", null, [
                _createElementVNode("tr", null, [
                  _hoisted_54,
                  _hoisted_55,
                  _createElementVNode("td", null, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.quotation.vehicle_type), 1)
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_56,
                  _hoisted_57,
                  _createElementVNode("td", null, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.quotation.vehicle_ownership), 1)
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_58,
                  _hoisted_59,
                  _createElementVNode("td", null, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.quotation.vehicle_reg_no), 1)
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_60,
                  _hoisted_61,
                  _createElementVNode("td", null, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.quotation.vehicle_reg_year), 1)
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_62,
                  _hoisted_63,
                  _createElementVNode("td", null, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.quotation.vehicle_brand), 1)
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_64,
                  _hoisted_65,
                  _createElementVNode("td", null, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.quotation.vehicle_model), 1)
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_66,
                  _hoisted_67,
                  _createElementVNode("td", null, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.quotation.vehicle_engine_cc), 1)
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_68,
                  _hoisted_69,
                  _createElementVNode("td", null, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.quotation.vehicle_body_type), 1)
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_70,
                  _hoisted_71,
                  _createElementVNode("td", null, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.quotation.no_of_seat), 1)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_72, [
          _createElementVNode("div", _hoisted_73, [
            _hoisted_74,
            _createElementVNode("div", _hoisted_75, [
              _createElementVNode("table", null, [
                _createElementVNode("tr", null, [
                  _hoisted_76,
                  _hoisted_77,
                  _createElementVNode("td", null, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.quotation.cover_type), 1)
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_78,
                  _hoisted_79,
                  _createElementVNode("td", null, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.quotation.cover_type != '3rd Party' ? 'RM ' + _ctx.quotation_package.sum_insured : '-'), 1)
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_80,
                  _hoisted_81,
                  _createElementVNode("td", null, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.quotation_package.insurance_company_name), 1)
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_82,
                  _hoisted_83,
                  _createElementVNode("td", null, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.formatDatePeriod(_ctx.quotation.sum_insured_from)), 1)
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_84,
                  _hoisted_85,
                  _createElementVNode("td", null, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.formatDatePeriod(_ctx.quotation.sum_insured_to)), 1)
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_86,
                  _hoisted_87,
                  _createElementVNode("td", null, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.payments.payment_method), 1)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_88, [
          _createElementVNode("div", _hoisted_89, [
            _hoisted_90,
            _createElementVNode("div", _hoisted_91, [
              _createElementVNode("table", _hoisted_92, [
                _createElementVNode("tr", null, [
                  _hoisted_93,
                  _createElementVNode("td", null, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, [
                        _hoisted_94,
                        _createElementVNode("span", _hoisted_95, _toDisplayString(_ctx.convertTo2Decimal(
                            _ctx.quotation_package.original_premium_price
                          )), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, [
                    _createElementVNode("p", null, " NCD Discount (" + _toDisplayString(_ctx.quotation_package.ncd_discount_percentage) + " %) ", 1)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, [
                        _hoisted_96,
                        _hoisted_97,
                        _createElementVNode("span", _hoisted_98, _toDisplayString(_ctx.convertTo2Decimal(
                            _ctx.quotation_package.ncd_discount_amount
                          )), 1)
                      ])
                    ])
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.add_on, (addon) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: addon.id
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("p", null, _toDisplayString(addon.item_name), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("p", null, [
                        _createElementVNode("strong", null, [
                          _hoisted_99,
                          _createElementVNode("span", _hoisted_100, _toDisplayString(_ctx.convertTo2Decimal(addon.item_price) > 0
                            ? _ctx.convertTo2Decimal(addon.item_price)
                            : "0.00"), 1)
                        ])
                      ])
                    ])
                  ]))
                }), 128)),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, [
                    _createElementVNode("p", null, " Total Discount (" + _toDisplayString(_ctx.insurance.insurance_discount_percentage) + " %) ", 1)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, [
                        _hoisted_101,
                        _hoisted_102,
                        _createElementVNode("span", _hoisted_103, _toDisplayString(_ctx.convertTo2Decimal(_ctx.order.total_discount) > 0
                            ? _ctx.convertTo2Decimal(_ctx.order.total_discount)
                            : "0.00"), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_104,
                  _createElementVNode("td", null, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, [
                        _hoisted_105,
                        _createElementVNode("span", _hoisted_106, _toDisplayString(_ctx.convertTo2Decimal(_ctx.order.total_tax)), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_107,
                  _createElementVNode("td", null, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, [
                        _hoisted_108,
                        _createElementVNode("span", _hoisted_109, _toDisplayString(_ctx.convertTo2Decimal(_ctx.order.stamp_duty_fee)), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_110,
                  _createElementVNode("td", null, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, [
                        _hoisted_111,
                        _createElementVNode("span", _hoisted_112, _toDisplayString(_ctx.convertTo2Decimal(_ctx.order.delivery_fee)), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_113, [
                  _hoisted_114,
                  _createElementVNode("td", null, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, [
                        _hoisted_115,
                        _createElementVNode("span", _hoisted_116, _toDisplayString(_ctx.convertTo2Decimal(_ctx.order.total)), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _hoisted_117
  ]))
}